import { mapGetters } from 'vuex'

import render from './render'

export default {
  name: 'ButtonNotifications',

  data() {
    return {
      show: false
    }
  },

  computed: {
    ...mapGetters({ hasNewVersion: 'version/hasNewVersion' })
  },

  render
}
